import util from '@bmp-vue/core/api/util'

const controller = 'Favorecidos'

export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllFavorecidosByConta: (codigoConta) => {
    return util.Axios.Get(controller + '/GetAllFavorecidosByConta', codigoConta)
  },
  PostContaFavorecido: (dto) => {
    return util.Axios.Post(controller + '/PostContaFavorecido', dto)
  },
  PutContaFavorecido: (dto) => {
    return util.Axios.Put(controller + '/PutContaFavorecido', '', dto)
  }
})
